import type { WorkSchedule, WorkScheduleDay } from '@trinnvis/dabih-api-client';
import { LocalDate } from '../../../utilities/local-date';
import { defaultWorkSchedule } from './default-work-schedule';
import { sortBy } from 'lodash';

export function employeeCurrentSchedule(workSchedules: WorkSchedule[], date: LocalDate): WorkSchedule {
  let currentSchedule: WorkSchedule = defaultWorkSchedule;
  const validWorkSchedules = workSchedules.filter((schedule) =>
    LocalDate.fromString(schedule.start).isSameOrBefore(date),
  );

  if (validWorkSchedules.length > 0) {
    const orderedWorkSchedules = sortBy(validWorkSchedules, (e) => e.start);
    currentSchedule = orderedWorkSchedules[orderedWorkSchedules.length - 1];
  }

  const normalizeWorkDay = (d: WorkScheduleDay): WorkScheduleDay => {
    if (d.workDay) {
      return {
        workDay: true,
        start: currentSchedule.workDayStartTime || '08:00',
        end: currentSchedule.workDayEndTime || '16:00',
      };
    } else {
      return {
        workDay: false,
      };
    }
  };

  return {
    ...currentSchedule,
    workWeeks: currentSchedule.workHoursDefinedPerDay
      ? currentSchedule.workWeeks
      : currentSchedule.workWeeks.map((w) => {
          return {
            monday: normalizeWorkDay(w.monday),
            tuesday: normalizeWorkDay(w.tuesday),
            wednesday: normalizeWorkDay(w.wednesday),
            thursday: normalizeWorkDay(w.thursday),
            friday: normalizeWorkDay(w.friday),
            saturday: normalizeWorkDay(w.saturday),
            sunday: normalizeWorkDay(w.sunday),
          };
        }),
  };
}
